import { render, staticRenderFns } from "./Manuals.vue?vue&type=template&id=ddf8143e&"
import script from "./Manuals.vue?vue&type=script&lang=js&"
export * from "./Manuals.vue?vue&type=script&lang=js&"
import style0 from "./Manuals.vue?vue&type=style&index=0&id=ddf8143e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports